import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "../styles/components/Cart.scss";

function Cart() {
  const { items, updateQty, removeItem } = useCart();

  const getImageUrl = (img) =>
    img
      ? `${API_BASE_URL}/images/products/${img}`
      : `${API_BASE_URL}/images/products/default.jpg`;

  const hasDiscount = (item) =>
    Number(item.discount_percentage) > 0 &&
    Number(item.final_price) > 0 &&
    Number(item.final_price) < Number(item.original_price);

  const getPrice = (item) =>
    hasDiscount(item)
      ? Number(item.final_price)
      : Number(item.original_price);

  const subtotal = items.reduce(
    (acc, item) => acc + getPrice(item) * item.qty,
    0
  );

  if (!items.length) {
    return (
      <div className="cart-page empty">
        <h2>Your cart is empty</h2>
        <Link to="/categories" className="btn-primary">
          Browse Products
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-items">
        {items.map((item) => {
          const price = getPrice(item);

          return (
            <div className="cart-card" key={`${item.id}-${item.colorId ?? "none"}`}>
              <img src={getImageUrl(item.image)} alt={item.name} />

              <div className="info">
                <h3>{item.name}</h3>
                {item.colorName && (
                  <p className="cart-card-color">
                    <span
                      className="cart-card-color-dot"
                      style={{ backgroundColor: item.colorHex || "#888" }}
                    />
                    {item.colorName}
                  </p>
                )}

                <div className="controls">
                  <button
                    type="button"
                    aria-label={`Decrease quantity of ${item.name}`}
                    onClick={() => updateQty(item.id, item.qty - 1, item.colorId)}
                  >
                    -
                  </button>
                  <span>{item.qty}</span>
                  <button
                    type="button"
                    aria-label={`Increase quantity of ${item.name}`}
                    onClick={() => updateQty(item.id, item.qty + 1, item.colorId)}
                  >
                    +
                  </button>
                </div>

                {/* السعر النهائي */}
                <div className="price">
                  ${(price * item.qty).toFixed(2)}
                </div>

                {/* السعر القديم */}
                {hasDiscount(item) && (
                  <div className="old-price">
                    ${(Number(item.original_price) * item.qty).toFixed(2)}
                  </div>
                )}

                <button
                  type="button"
                  className="remove"
                  aria-label={`Remove ${item.name} from cart`}
                  onClick={() => removeItem(item.id, item.colorId)}
                >
                  Remove
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="cart-summary">
        <h3>Order Summary</h3>

        <div className="row">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>

        <Link to="/checkout" className="btn-primary">
          Proceed to Checkout
        </Link>
      </div>
    </div>
  );
}

export default Cart;